import { TypeDefinition } from "../generic";

export class FieldTypes {
    public static Text: TypeDefinition = { id: 1, name: "Text" };
    public static MultilineText: TypeDefinition = { id: 2, name: "MultilineText" };
    public static RichText: TypeDefinition = { id: 3, name: "RichText" };
    public static Number: TypeDefinition = { id: 4, name: "Number" };
    public static Integer: TypeDefinition = { id: 5, name: "Integer" };
    public static Checkbox: TypeDefinition = { id: 6, name: "Checkbox" };
    public static Date: TypeDefinition = { id: 7, name: "Date" };
    public static Dropdown: TypeDefinition = { id: 8, name: "Dropdown" };
    public static RadioList: TypeDefinition = { id: 9, name: "RadioList" };
    public static CheckList: TypeDefinition = { id: 10, name: "CheckList" };
    public static FileUpload: TypeDefinition = { id: 11, name: "FileUpload" };
    public static EmailAddress: TypeDefinition = { id: 12, name: "Email address" };
    public static DateTime: TypeDefinition = { id: 13, name: "Date + time" };
    public static TimeSpan: TypeDefinition = { id: 14, name: "Timespan" };
    public static TimeSpanMinutes: TypeDefinition = { id: 15, name: "Timespan (minutes)" };

    public static Values: TypeDefinition[] = [
        FieldTypes.Checkbox,
        FieldTypes.CheckList,
        FieldTypes.Date,
        FieldTypes.DateTime,
        FieldTypes.Dropdown,
        FieldTypes.EmailAddress,
        FieldTypes.FileUpload,
        FieldTypes.Integer,
        FieldTypes.MultilineText,
        FieldTypes.Number,
        FieldTypes.RadioList,
        FieldTypes.RichText,
        FieldTypes.Text,
        FieldTypes.TimeSpan,
        FieldTypes.TimeSpanMinutes,
    ];

    public static isListType(x: number | { typeId: number }) {
        const typeId = typeof x === "number" ? x : x.typeId;
        return [
            FieldTypes.Dropdown.id,
            FieldTypes.RadioList.id,
            FieldTypes.CheckList.id,
        ].indexOf(typeId) > -1;
    }

    public static isTextType(x: number | { typeId: number }) {
        const typeId = typeof x === "number" ? x : x.typeId;
        return [
            FieldTypes.MultilineText.id,
            FieldTypes.RichText.id,
            FieldTypes.Text.id,
        ].indexOf(typeId) > -1;
    }

    public static isTimeSpanType(x: number | { typeId: number }) {
        const typeId = typeof x === "number" ? x : x.typeId;
        return [
            FieldTypes.TimeSpan.id,
            FieldTypes.TimeSpanMinutes.id,
        ].indexOf(typeId) > -1;
    }
}



// WEBPACK FOOTER //
// ./src/models/formBuilder/FieldTypes.ts